import { z } from 'zod';

export const PwaForceInstallSchema = z
	.object({
		android: z.array(z.string()).default([]),
		ios: z.array(z.string()).default([])
	})
	.default({});

export type PwaForceInstallType = z.infer<typeof PwaForceInstallSchema>;
